import { render } from "./SecurityGroupSelection.vue?vue&type=template&id=66e0a85e&scoped=true"
import script from "./SecurityGroupSelection.vue?vue&type=script&lang=js"
export * from "./SecurityGroupSelection.vue?vue&type=script&lang=js"

import "./SecurityGroupSelection.vue?vue&type=style&index=0&id=66e0a85e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e0a85e"]])

export default __exports__